import { apiPost, getToken } from "../../services/apiClient";
import { isAdmin, logoutLocalStorage } from "../../services/localStorage";
import { Person } from "../../types/Entities/Person";
import { Prelead } from "../../types/Prelead";
import { FormDataTypes } from "../../types/FormDataTypes";
import { gaEvent } from "../../services/googleAnalyticsService";

interface RegisterData {
  email: string;
  gclid?: string | null;
  telephone?: string;
  person?: Partial<Person>;
  prelead: Prelead;
}

export async function register(data: RegisterData) {
  const { token } = await apiPost("/customers", data);
  localStorage.setItem("token", token);
  gaEvent({
    category: "Registration",
    action: "Account created",
  });
}

export function login(credentials: { email: string; password: string }) {
  gaEvent({
    category: "Login",
    action: "logged in",
  });
  return getToken(credentials);
}

export async function loginImpersonate(data: FormDataTypes["values"]) {
  const adminToken = await getToken({ email: data.email.toLowerCase(), password: data.password });
  if (isAdmin(adminToken)) {
    localStorage.setItem("impersonate", data.login);
  }
}

export function logout() {
  gaEvent({
    category: "Customer",
    action: "Logged out",
    nonInteraction: true,
  });
  logoutLocalStorage();
}

export async function checkEmail(email: string) {
  try {
    let response = await apiPost("/check_email", { email: email.toLowerCase() });
    response.hasError = response.customerExists;
    response.errorText = null;
    return response;
  } catch (e) {
    return {
      hasError: true,
      errorText: "Ihre E-Mail-Adresse ist ungültig",
    };
  }
}
